import { combineReducers } from 'redux'
import auth from './AuthReducer'
import user from './UserReducer'
import view from './ViewReducer'
import campaign from "./campaignReducer"
import business from "./businessReducer"
export default combineReducers({
    auth,
    user,
    view,
    business,
    campaign
})